<script setup lang="ts">
const { description } = defineProps<{
  description: string;
  name: string;
}>();

const isFullTextShown = ref(false);
const descriptionText = computed(() =>
  isFullTextShown.value || (description?.length && description?.length <= 800)
    ? description
    : `${description?.slice(0, 800).trim()}...`,
);
</script>

<template>
  <div class="site-viewport-container">
    <h2 class="flex font-bold uppercase text-2xl">
      {{ $t("category.description.about", { categoryName: name }) }}
    </h2>
    <p class="py-2">
      {{ descriptionText }}
    </p>
    <BaseButton
      v-if="description.length && description.length > 800"
      color-scheme="floating"
      @click="isFullTextShown = !isFullTextShown"
    >
      {{
        isFullTextShown
          ? $t("category.description.showLess")
          : $t("category.description.showMore")
      }}
    </BaseButton>
  </div>
</template>
